module.exports = __webpack_public_path__ + "public/images/writing.39405293929ed2acb1628dd2add174c2.png";